<template>
  <v-app>
    <v-navigation-drawer app v-model="drawer" color="#003366" dark>
      <v-list dense nav>
        <v-list-item class="px-2 mb-2">
           <v-list-item-title class="text-h6 font-weight-bold white--text">
             iTPV Manager
           </v-list-item-title>
        </v-list-item>

        <!-- Elementos de navegación -->
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :to="item.route"
          link
          active-class="primary--text text--lighten-5"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-model="inventoryOpen"
          prepend-icon="mdi-archive-outline"
          color="white"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Inventario</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="item in inventoryMenuItems"
            :key="item.title"
            :to="item.route"
            link
            active-class="primary--text text--lighten-5"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-model="reportsOpen"
          prepend-icon="mdi-chart-bar"
          color="white"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Reportes</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="item in reportMenuItems"
            :key="item.title"
            :to="item.route"
            link
            active-class="primary--text text--lighten-5"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <template v-slot:append>
        <v-list dense nav>
          <v-list-item>
            <v-list-item-content>
              <v-select
                v-model="selectedTimezone"
                :items="timezoneOptions"
                item-text="label"
                item-value="value"
                label="Zona horaria"
                dense
                outlined
                hide-details
                dark
                class="timezone-select mb-2"
                @change="handleTimezoneChange"
              ></v-select>
            </v-list-item-content>
          </v-list-item>
           <v-list-item @click="logout" link>
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

    </v-navigation-drawer>

    <v-app-bar app color="white" flat class="border-bottom">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-avatar color="grey lighten-3" size="36">
              <!-- Aquí puedes poner iniciales o una imagen de perfil -->
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
         <v-list dense>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon small>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main class="grey lighten-4">
      <!-- El contenido principal se renderizará aquí -->
      <router-view @show-alert="(options) => $emit('show-alert', options)"/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'AppDashboard',
  data() {
    return {
      drawer: true, // Mantenemos el drawer visible por defecto en pantallas grandes
      inventoryOpen: true,
      reportsOpen: true,
      selectedTimezone: 'America/Mexico_City',
      timezoneOptions: [
        { label: 'Ciudad de México', value: 'America/Mexico_City' },
        { label: 'Monterrey', value: 'America/Monterrey' },
        { label: 'Tijuana', value: 'America/Tijuana' },
        { label: 'Bogotá', value: 'America/Bogota' },
        { label: 'Lima', value: 'America/Lima' },
        { label: 'Santiago', value: 'America/Santiago' },
        { label: 'Buenos Aires', value: 'America/Argentina/Buenos_Aires' },
        { label: 'Madrid', value: 'Europe/Madrid' },
        { label: 'UTC', value: 'UTC' },
      ],
      userRole: null,
      userName: null,
      menuItems: [
        { title: 'Dashboard', icon: 'mdi-view-dashboard', route: '/admin/dashboard' },
        { title: 'Cierre de caja', icon: 'mdi-cash-register', route: '/admin/cash-closure' },
        { title: 'Ventas', icon: 'mdi-cart-outline', route: '/admin/sales' }, // Ajusta la ruta si es necesario
        { title: 'Clientes', icon: 'mdi-account-group-outline', route: '/admin/clients' }, // Ajusta la ruta si es necesario
        { title: 'Configuración', icon: 'mdi-cog-outline', route: '/admin/settings' }, // Ajusta la ruta si es necesario
      ],
      inventoryMenuItems: [
        { title: 'Productos', icon: 'mdi-package-variant-closed', route: '/admin/products' },
        { title: 'Categorías', icon: 'mdi-shape-outline', route: '/admin/categories' },
        { title: 'Gestión de inventario', icon: 'mdi-warehouse', route: '/admin/inventory' },
      ],
      reportMenuItems: [
        { title: 'Ventas', icon: 'mdi-cash-multiple', route: '/admin/reports/sales' },
        { title: 'Inventario', icon: 'mdi-clipboard-list-outline', route: '/admin/reports/inventory' },
        { title: 'Clientes', icon: 'mdi-account-box-multiple-outline', route: '/admin/reports/clients' },
      ],
    };
  },
  created() {
    this.loadUserInfo();
    this.loadTimezonePreference();
  },
  methods: {
    loadTimezonePreference() {
      const savedTimezone = localStorage.getItem('appTimezone');
      if (savedTimezone) {
        this.selectedTimezone = savedTimezone;
      } else {
        localStorage.setItem('appTimezone', this.selectedTimezone);
      }
    },
    handleTimezoneChange(timezone) {
      localStorage.setItem('appTimezone', timezone);
      window.dispatchEvent(new CustomEvent('app-timezone-changed', { detail: timezone }));
    },
    loadUserInfo() {
      const token = localStorage.getItem('token');
      const userRole = localStorage.getItem('userRole');
      const userName = localStorage.getItem('userName');
      
      // Verificación básica: si no hay token, el guard de ruta ya debería haber redirigido
      // Pero podemos mantener una comprobación aquí por si acaso o para cargar datos.
      if (!token) { 
         console.error("Dashboard accedido sin token."); // Opcional: loguear si esto ocurre
         this.logout(); // Forzar logout si se llega aquí sin token
         return;
      }
      
      this.userRole = userRole;
      this.userName = userName;
      
      // Eliminada la lógica de redirección basada en roles y ruta '/'
      // El router ahora maneja la redirección a /dashboard
    },
    
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userId'); // Asegurarse de limpiar todo lo relacionado
      localStorage.removeItem('userName');
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #e0e0e0 !important;
}

.v-main {
  padding: 0 !important;
}

.timezone-select {
  min-width: 200px;
}

/* Estilo para el item activo */
.v-list-item--active {
  background-color: rgba(255, 255, 255, 0.1);
}

.v-navigation-drawer ::-webkit-scrollbar {
  width: 0px;
}

.v-navigation-drawer {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
}

</style> 